module.exports = __webpack_public_path__ + "img/Paris Awaits With Personalized Service.99ab738c.jpg";